import { SearchesState, SearchesAction, CandidatePoolsState, CandidatePoolsAction } from './types';
import { searchTableColumn } from './SearchTableRows';
import { candidatePoolTableColumn } from './CandidatePoolTableRows';

export const InitialSearchesState: SearchesState = {
  snackbar: {
    message: '',
    state: 'success'
  },
  searchesTableState: {
    canScroll: [false, false],
    tableHovered: false,
    density: 'Default',
    columns: searchTableColumn,
    selectedItemIds: [],
    selectedItems: [],
    modalsOpen: {},
    actions: {
      selectedItem: null,
      anchorEl: null,
      isOpen: {}
    }
  },
  searchesTableSettings: {
    page: 1,
    limit: 20,
    sort: 'id',
    sort_order: 'desc'
  },
  searchQuery: '',
  totalPages: 0,
  searchesCount: 0
};

export const InitialCandidatePoolsState: CandidatePoolsState = {
  snackbar: {
    message: '',
    state: 'success'
  },
  candidatePoolsTableState: {
    canScroll: [false, false],
    tableHovered: false,
    density: 'Default',
    columns: candidatePoolTableColumn,
    selectedItemIds: [],
    selectedItems: [],
    modalsOpen: {
      email: false
    },
    actions: {
      selectedItem: null,
      anchorEl: null,
      isOpen: {}
    }
  },
  candidatePoolsTableSettings: {
    page: 1,
    limit: 20,
    sort: 'id',
    sort_order: 'desc'
  },
  searchQuery: '',
  totalPages: 0,
  candidatePoolsCount: 0
};

export const SearchesReducer = (state: SearchesState, action: SearchesAction): SearchesState => {
  switch (action.type) {
    case 'SET_SNACKBAR':
      return {
        ...state,
        snackbar: action.payload
      };
    case 'SET_SEARCH_QUERY':
      return {
        ...state,
        searchQuery: action.payload,
        searchesTableSettings: {
          ...state.searchesTableSettings,
          page: 1
        }
      };
    case 'CLEAR_SEARCH_QUERY':
      return {
        ...state,
        searchQuery: '',
        searchesTableSettings: {
          ...state.searchesTableSettings,
          page: 1
        }
      };
    case 'SET_TOTAL_PAGES':
      return {
        ...state,
        totalPages: action.payload
      };
    case 'SET_SEARCHES_COUNT':
      return {
        ...state,
        searchesCount: action.payload
      };
    case 'SET_DENSITY':
      return {
        ...state,
        searchesTableState: {
          ...state.searchesTableState,
          density: action.payload
        }
      };
    case 'SET_DEFAULT_DATA':
      return {
        ...state,
        searchesTableState: {
          ...state.searchesTableState,
          ...action.payload
        }
      };
    case 'SET_CAN_SCROLL':
      return {
        ...state,
        searchesTableState: {
          ...state.searchesTableState,
          canScroll: action.payload
        }
      };
    case 'SET_TABLE_HOVERED':
      return {
        ...state,
        searchesTableState: {
          ...state.searchesTableState,
          tableHovered: action.payload
        }
      };
    case 'ADD_SELECTED_ITEM':
      return {
        ...state,
        searchesTableState: {
          ...state.searchesTableState,
          selectedItems: [...state.searchesTableState.selectedItems, action.payload],
          selectedItemIds: [...state.searchesTableState.selectedItemIds, action.payload.id]
        }
      };
    case 'REMOVE_SELECTED_ITEM':
      return {
        ...state,
        searchesTableState: {
          ...state.searchesTableState,
          selectedItems: state.searchesTableState.selectedItems.filter(
            (item) => item.id !== action.payload
          ),
          selectedItemIds: state.searchesTableState.selectedItemIds.filter(
            (id) => id !== action.payload
          )
        }
      };
    case 'ADD_ALL_PAGE_ITEMS':
      return {
        ...state,
        searchesTableState: {
          ...state.searchesTableState,
          selectedItems: [...state.searchesTableState.selectedItems, ...action.payload],
          selectedItemIds: [
            ...state.searchesTableState.selectedItemIds,
            ...action.payload.map((item) => item.id)
          ]
        }
      };
    case 'REMOVE_ALL_SELECTED_ITEMS':
      return {
        ...state,
        searchesTableState: {
          ...state.searchesTableState,
          selectedItems: [],
          selectedItemIds: []
        }
      };
    case 'REMOVE_ALL_PAGE_ITEMS':
      return {
        ...state,
        searchesTableState: {
          ...state.searchesTableState,
          selectedItems: state.searchesTableState.selectedItems.filter(
            (item) => !action.payload.includes(item.id)
          ),
          selectedItemIds: state.searchesTableState.selectedItemIds.filter(
            (id) => !action.payload.includes(id)
          )
        }
      };
    case 'SELECT_ALL_ITEMS':
      return {
        ...state,
        searchesTableState: {
          ...state.searchesTableState,
          selectedItemIds: action.payload
        }
      };
    case 'SET_COLUMNS':
      return {
        ...state,
        searchesTableState: {
          ...state.searchesTableState,
          columns: action.payload
        }
      };
    case 'SET_PAGE':
      return {
        ...state,
        searchesTableSettings: {
          ...state.searchesTableSettings,
          page: action.payload
        }
      };
    case 'SET_LIMIT':
      return {
        ...state,
        searchesTableSettings: {
          ...state.searchesTableSettings,
          limit: action.payload
        }
      };
    case 'SET_SORT':
      return {
        ...state,
        searchesTableSettings: {
          ...state.searchesTableSettings,
          sort: action.payload.sortBy,
          sort_order: action.payload.sortOrder
        }
      };
    case 'SELECT_ACTION_ITEM':
      return {
        ...state,
        searchesTableState: {
          ...state.searchesTableState,
          actions: {
            ...state.searchesTableState.actions,
            selectedItem: action.payload.item,
            anchorEl: action.payload.anchorEl,
            isOpen: {
              ...state.searchesTableState.actions.isOpen,
              [action.payload.name]: true
            }
          }
        }
      };
    case 'CLOSE_ACTION_ITEM':
      return {
        ...state,
        searchesTableState: {
          ...state.searchesTableState,
          actions: {
            ...state.searchesTableState.actions,
            isOpen: {
              ...state.searchesTableState.actions.isOpen,
              [action.payload]: false
            }
          }
        }
      };
    case 'SET_ACTION_MODAL_OPEN':
      return {
        ...state,
        searchesTableState: {
          ...state.searchesTableState,
          modalsOpen: {
            ...state.searchesTableState.modalsOpen,
            [action.payload.name]: action.payload.isOpen
          }
        }
      };
    case 'SET_SELECTED_ROW_DATA':
      return state;
    case 'REMOVE_SELECTED_ROW_DATA':
      return state;
    default:
      return state;
  }
};

export const CandidatePoolsReducer = (
  state: CandidatePoolsState,
  action: CandidatePoolsAction
): CandidatePoolsState => {
  switch (action.type) {
    case 'SET_SNACKBAR':
      return {
        ...state,
        snackbar: action.payload
      };
    case 'SET_SEARCH_QUERY':
      return {
        ...state,
        searchQuery: action.payload,
        candidatePoolsTableSettings: {
          ...state.candidatePoolsTableSettings,
          page: 1
        }
      };
    case 'CLEAR_SEARCH_QUERY':
      return {
        ...state,
        searchQuery: '',
        candidatePoolsTableSettings: {
          ...state.candidatePoolsTableSettings,
          page: 1
        }
      };
    case 'SET_TOTAL_PAGES':
      return {
        ...state,
        totalPages: action.payload
      };
    case 'SET_CANDIDATE_POOLS_COUNT':
      return {
        ...state,
        candidatePoolsCount: action.payload
      };
    case 'SET_DENSITY':
      return {
        ...state,
        candidatePoolsTableState: {
          ...state.candidatePoolsTableState,
          density: action.payload
        }
      };
    case 'SET_DEFAULT_DATA':
      return {
        ...state,
        candidatePoolsTableState: {
          ...state.candidatePoolsTableState,
          ...action.payload
        }
      };
    case 'SET_CAN_SCROLL':
      return {
        ...state,
        candidatePoolsTableState: {
          ...state.candidatePoolsTableState,
          canScroll: action.payload
        }
      };
    case 'SET_TABLE_HOVERED':
      return {
        ...state,
        candidatePoolsTableState: {
          ...state.candidatePoolsTableState,
          tableHovered: action.payload
        }
      };
    case 'ADD_SELECTED_ITEM':
      return {
        ...state,
        candidatePoolsTableState: {
          ...state.candidatePoolsTableState,
          selectedItems: [...state.candidatePoolsTableState.selectedItems, action.payload],
          selectedItemIds: [...state.candidatePoolsTableState.selectedItemIds, action.payload.id]
        }
      };
    case 'REMOVE_SELECTED_ITEM':
      return {
        ...state,
        candidatePoolsTableState: {
          ...state.candidatePoolsTableState,
          selectedItems: state.candidatePoolsTableState.selectedItems.filter(
            (item) => item.id !== action.payload
          ),
          selectedItemIds: state.candidatePoolsTableState.selectedItemIds.filter(
            (id) => id !== action.payload
          )
        }
      };
    case 'ADD_ALL_PAGE_ITEMS':
      return {
        ...state,
        candidatePoolsTableState: {
          ...state.candidatePoolsTableState,
          selectedItems: [...state.candidatePoolsTableState.selectedItems, ...action.payload],
          selectedItemIds: [
            ...state.candidatePoolsTableState.selectedItemIds,
            ...action.payload.map((item) => item.id)
          ]
        }
      };
    case 'REMOVE_ALL_SELECTED_ITEMS':
      return {
        ...state,
        candidatePoolsTableState: {
          ...state.candidatePoolsTableState,
          selectedItems: [],
          selectedItemIds: []
        }
      };
    case 'REMOVE_ALL_PAGE_ITEMS':
      return {
        ...state,
        candidatePoolsTableState: {
          ...state.candidatePoolsTableState,
          selectedItems: state.candidatePoolsTableState.selectedItems.filter(
            (item) => !action.payload.includes(item.id)
          ),
          selectedItemIds: state.candidatePoolsTableState.selectedItemIds.filter(
            (id) => !action.payload.includes(id)
          )
        }
      };
    case 'SELECT_ALL_ITEMS':
      return {
        ...state,
        candidatePoolsTableState: {
          ...state.candidatePoolsTableState,
          selectedItemIds: action.payload
        }
      };
    case 'SET_COLUMNS':
      return {
        ...state,
        candidatePoolsTableState: {
          ...state.candidatePoolsTableState,
          columns: action.payload
        }
      };
    case 'SET_PAGE':
      return {
        ...state,
        candidatePoolsTableSettings: {
          ...state.candidatePoolsTableSettings,
          page: action.payload
        }
      };
    case 'SET_LIMIT':
      return {
        ...state,
        candidatePoolsTableSettings: {
          ...state.candidatePoolsTableSettings,
          limit: action.payload
        }
      };
    case 'SET_SORT':
      return {
        ...state,
        candidatePoolsTableSettings: {
          ...state.candidatePoolsTableSettings,
          sort: action.payload.sortBy,
          sort_order: action.payload.sortOrder
        }
      };
    case 'SELECT_ACTION_ITEM':
      return {
        ...state,
        candidatePoolsTableState: {
          ...state.candidatePoolsTableState,
          actions: {
            ...state.candidatePoolsTableState.actions,
            selectedItem: action.payload.item,
            anchorEl: action.payload.anchorEl,
            isOpen: {
              ...state.candidatePoolsTableState.actions.isOpen,
              [action.payload.name]: true
            }
          }
        }
      };
    case 'CLOSE_ACTION_ITEM':
      return {
        ...state,
        candidatePoolsTableState: {
          ...state.candidatePoolsTableState,
          actions: {
            ...state.candidatePoolsTableState.actions,
            isOpen: {
              ...state.candidatePoolsTableState.actions.isOpen,
              [action.payload]: false
            }
          }
        }
      };
    case 'SET_ACTION_MODAL_OPEN':
      return {
        ...state,
        candidatePoolsTableState: {
          ...state.candidatePoolsTableState,
          modalsOpen: {
            ...state.candidatePoolsTableState.modalsOpen,
            [action.payload.name]: action.payload.isOpen
          }
        }
      };
    case 'SET_SELECTED_ROW_DATA':
      return state;
    case 'REMOVE_SELECTED_ROW_DATA':
      return state;
    default:
      return state;
  }
};
